import { AdjustmentsManagerPage } from "./AdjustmentManagerPage";

type Props = {};
const AdjustmentManager = (props: Props) => {
	return <AdjustmentsManagerPage />;
};
export default AdjustmentManager;
